import { Grid, NoSsr, Card, CardActionArea, CardContent, CardMedia, Typography, CardActions, Button, useMediaQuery, Dialog, DialogContent, useTheme, Box, CircularProgress } from "@material-ui/core";
import React, { Fragment, useState } from "react";
import { Trans } from 'react-i18next'
import { useAuth } from "../context/useFetch";
import { useRouter } from 'next/router'
import Link from 'next/link'
import { useSelector } from "react-redux";
import { RESUME_HOST, RESUME_PDF_HOST } from "../../src/constants";
import { useAlert } from "../reducer";
import i18n from "../i18n/i18n";

const TEMPLATES = ['cv-professionnel', 'cool-rtl', 'left-right-projects', 'material-dark-projects', 'oblique', 'side-bar-projects', 'cv-classique']

const Generator = () => {
  const [chosenTemplate, setChosenTemplate] = useState(null)
  const [isPreviewing, setIsPreviewing] = useState(false)
  const [sender, setSender] = useState(null)

  const previewHandler = (template) => () => {
    setChosenTemplate(template)
    setIsPreviewing(true)
  }

  const closePreviewHandler = () => {
    setIsPreviewing(false)
    setSender(null)
  }

  const downloadHandler = () => {
    setSender('download')
  }

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))
  const router = useRouter()

  const alert = useAlert()

  const auth = useAuth()

  const headers = btoa(JSON.stringify(auth.headers()))

  const fullName = useSelector(({ profile }) => [profile.first_name, profile.last_name].filter(Boolean).join(' '))

  const pdfGenerationPath = `headers=${headers}&full_name=${encodeURI(fullName)}`

  const addToProfile = (template) => () => {
    setSender('addToProfile')
    const path = `template=${template}&${pdfGenerationPath}`
    auth.fetch('profile', { method: 'PATCH', body: { profile: { add_generated_document: path } } })
      .then(() => {
        setIsPreviewing(false)
        setSender(null)
        setChosenTemplate(() => {
          router.push('/profile/documents')
          setTimeout(() => {
            alert('notice', i18n.t('profile.generator.add_to_profile.success'))
            window.scrollTo(0, document.body.scrollHeight)
          }, 100)
        })
      }).catch(() => {
        alert('error', i18n.t('profile.generator.add_to_profile.error'))
        setSender(null)
      })
  }

  return (
    <Fragment>
      <Typography variant="h2" component="h1">
        <Trans i18nKey="profile.generator.title" />
        &nbsp;
        <sup><small>Beta</small></sup>
      </Typography>

      <Grid className="profileSection">
        <Box mb={4}>
          <Typography>
            <Trans i18nKey="profile.generator.sub_title" />
          </Typography>
        </Box>

        <Grid container spacing={2}>
          {TEMPLATES.map((template) => (
            <Grid item xs={12} sm={6} md={4}>
              <Card variant="outlined">
                <CardActionArea onClick={previewHandler(template)}>
                  <CardMedia
                    image={`/resume-previews/resume-${template}.png`}
                    title="Contemplative Reptile"
                    style={{ aspectRatio: '1/1', backgroundPosition: '0 0' }}
                  />
                  <CardContent>
                    <Typography variant="body1" component="h2" style={{ marginBottom: '0' }}>
                      <Trans i18nKey={`profile.generator.resumes.${template}`} />
                    </Typography>
                  </CardContent>
                </CardActionArea>
                <CardActions>
                  <Button size="small" color="primary" onClick={previewHandler(template)}>
                    <Trans i18nKey="profile.generator.preview" />
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Grid>

      <Dialog fullScreen style={{ margin: isMobile ? 0 : '50px auto', maxWidth: '21cm', borderRadius: '4px !important' }} open={isPreviewing && chosenTemplate} onClose={closePreviewHandler}>
        <DialogContent style={{ padding: '0', position: 'relative' }}>

          <div style={{ padding: 32, textAlign: 'right' }}>
            <Link href={`${RESUME_PDF_HOST()}/generate?${pdfGenerationPath}&template=${chosenTemplate}`}>
              <Button size="small" variant="outlined" color="primary" disabled={Boolean(sender)} onClick={downloadHandler}>
                {sender === 'download' &&
                  <Fragment>
                    <CircularProgress style={{ width: '16px', height: '16px', verticalAlign: 'middle', marginRight: '8px' }} />
                  </Fragment>
                }
                <Trans i18nKey="profile.generator.download" />
              </Button>
            </Link>
            &nbsp;&nbsp;&nbsp;
            <Button size="small" variant="contained" color="primary" onClick={addToProfile(chosenTemplate)} disabled={sender === 'addToProfile' && Boolean(sender)}>
              {sender === 'addToProfile' &&
                <Fragment>
                  <CircularProgress style={{ width: '16px', height: '16px', verticalAlign: 'middle', marginRight: '8px' }} />
                </Fragment>
              }
              <Trans i18nKey="profile.generator.add_to_documents" />
            </Button>
          </div>

          <iframe src={`${RESUME_HOST()}/?${headers}#/resume/${chosenTemplate}`} border={0} style={{ width: '100%', height: '100vw', border: 0 }}></iframe>
        </DialogContent>
      </Dialog>
    </Fragment>
  )
}

export default () => {
  return (
    <NoSsr>
      <Generator />
    </NoSsr>
  )
}